import React from 'react';
import { formatPrice } from '../basket/basketUtils';
import PromoCodeLabel from './PromoCodeLabel';
import { orderPromoDetails } from '../../utils/orderPromoDetails';
import '../../styles/promo-codes.css';

export default function OrderPromoSummary({ order }) {
  if (!order?.promoCode) return null;
  return <div className='promo-order-summary d-flex flex-wrap align-items-baseline text-success' aria-label='Промокод замовлення'>
    <PromoCodeLabel promo={orderPromoDetails(order)} />
    <strong>−{formatPrice(order.promoDiscountAmount ?? 0)} грн</strong>
    {order.finalTotal === 0 && order.promoDiscountAmount > 0 && <small className='w-100'>Вартість товарів повністю покрита промокодом.</small>}
  </div>;
}
